"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightToBeForgotten = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var DeleteContentExplanation_1 = require("@features/SettingsPage/components/common/DeleteContentExplanation");
var Button_1 = __importDefault(require("@components/Button"));
var Modal_1 = __importDefault(require("@components/Modal"));
var _store_1 = require("@store");
var deleteContentSlice_1 = require("@features/SettingsPage/state/deleteContentSlice");
var ConfirmModal_1 = require("./ConfirmModal");
function RightToBeForgotten(_a) {
    var domain = _a.domain;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = __read(react_1.default.useState(false), 2), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = __read(react_1.default.useState(''), 2), userId = _c[0], setUserId = _c[1];
    var dispatch = (0, _store_1.useAppDispatch)();
    var submitDeleteUserData = function () {
        dispatch((0, deleteContentSlice_1.deleteUserData)(domain, userId)).then(function () {
            setIsModalOpen(false);
            setUserId('');
        });
    };
    var res = {
        willBeDeleted: [
            {
                text: t('settings:RIGHT_TO_BE_FORGOTTEN.WILL_BE_DELETED.TEXT1'),
                icon: 'implioicons-image-1',
            },
        ],
        willNotBeDeleted: [
            {
                text: t('settings:RIGHT_TO_BE_FORGOTTEN.WILL_NOT_BE_DELETED.TEXT1'),
                icon: 'implioicons-user',
            },
            {
                text: t('settings:RIGHT_TO_BE_FORGOTTEN.WILL_NOT_BE_DELETED.TEXT2'),
                icon: 'implioicons-statistics',
            },
            {
                text: t('settings:RIGHT_TO_BE_FORGOTTEN.WILL_NOT_BE_DELETED.TEXT3'),
                icon: 'implioicons-team',
            },
            {
                text: t('settings:RIGHT_TO_BE_FORGOTTEN.WILL_NOT_BE_DELETED.TEXT4'),
                icon: 'implioicons-network',
            },
        ],
    };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "delete-user-data" },
            react_1.default.createElement("h2", { className: "settings-page-title" },
                " ",
                t('settings:RIGHT_TO_BE_FORGOTTEN.TITLE')),
            react_1.default.createElement("div", { className: "row" },
                react_1.default.createElement("div", { className: "col-md-8" },
                    react_1.default.createElement("p", { className: "main-text" }, t('settings:RIGHT_TO_BE_FORGOTTEN.TEXT1')),
                    react_1.default.createElement("label", { htmlFor: "delete-user-data-input" }, t('settings:RIGHT_TO_BE_FORGOTTEN.USER_ID_LABEL')),
                    react_1.default.createElement("input", { id: "delete-user-data-input", value: userId, onChange: function (event) { return setUserId(event.target.value); }, placeholder: t('settings:RIGHT_TO_BE_FORGOTTEN.INPUT_PLACEHOLDER') || '' }),
                    react_1.default.createElement("div", { className: "gdpr__button-group" },
                        react_1.default.createElement(Button_1.default, { disabled: !userId, onClick: function () { return setIsModalOpen(true); }, text: t('settings:RIGHT_TO_BE_FORGOTTEN.DELETE_DATA_BUTTON') }))),
                react_1.default.createElement("div", { className: "col-md-4 right-side" },
                    react_1.default.createElement(DeleteContentExplanation_1.DeleteContentExplanation, { willBeDeleted: res.willBeDeleted, willNotBeDeleted: res.willNotBeDeleted })))),
        react_1.default.createElement(Modal_1.default, { isOpen: isModalOpen, setIsOpen: setIsModalOpen },
            react_1.default.createElement(ConfirmModal_1.ConfirmModal, { domain: domain, userId: userId, setIsModalOpen: setIsModalOpen, submitForm: submitDeleteUserData }))));
}
exports.RightToBeForgotten = RightToBeForgotten;
